const VARIABLE_REGEX = /\{\{\s*([^{}]+?)\s*\}\}/g

/**
 * Replace {{...}} tokens found in a text by the matching value for the given page (as
 * resolved from the "variables" store). The token is primarily the variable's id (stable
 * across renames) - matched by name as a fallback, to stay compatible with older texts
 * written before the switch to id-based tokens. Unmatched variables are replaced by an
 * empty string. Client-side mirror of the Lambda's resolveVariables
 * (microservices/packages/posting/3.autopost-news/helpers/resolveVariables.js),
 * used only to render the "Aperçu du réseau" preview - the raw {{...}} tokens are
 * kept in the text actually sent/stored, the Lambda does the real resolution.
 * @param {string} text
 * @param {Array<{id: string, name: string, value: string}>} variables
 * @returns {string}
 */
export function resolveVariables(text, variables = []) {
    if (!text) return text

    return text.replace(VARIABLE_REGEX, (_, token) => {
        const key = token.trim()
        const match = variables.find(v => v.id === key)
            || variables.find(v => v.name && v.name.trim().toLowerCase() === key.toLowerCase())
        return (match && match.value) || ''
    })
}
